// extracted by mini-css-extract-plugin
export default {"labelContainer":"yKue9B","label":"nAN4ok","label--required":"pxZg4A","label--disabled":"sXwlJx","infoContainer":"YVKuwT","description":"Zgkb9L"};